import React, { useCallback, useContext } from 'react'
import styled, { ThemeContext }  from 'styled-components'
import { AutoRow } from '../../../components/Row'
import Select, { OptionItem, curClassName } from '../../../components/Select/index'

import selectArtworkImg from '../../../assets/ido/select_nft.svg'
import selectImg from '../../../assets/ido/select.svg'
import sortAscCur from '../../../assets/ido/sort_asc_cur.svg'
import sortAsc from '../../../assets/ido/sort_asc.svg'
import IconArrowSort from '../../../assets/ido/icon_arrow_sort.svg'
import IconArrowBottom from '../../../assets/ido/icon_arrow_tab.svg'

export const ItemImg = styled.img<{ d?: OptionProps; cur?: OptionProps }>`
  width: auto;
  visibility: ${({d, cur}) => d?.key === cur?.key ? 'visible' : 'hidden'};
`
export const ItemLeftImg = styled.img<{ d?: OptionProps}>`
  width: 18px;
  height: 18px;
`

export const ItemDesc = styled.img<{ d?: OptionProps }>`
  transform: ${({d}) => d?.sortBy === 'desc' ? 'rotate(180deg)' : '0'};
`

export const ItemName = styled.div`
  margin-left: 10px;
`
export const MintName = styled(ItemName)<{d?: OptionProps}>`
  flex-grow: 1;
  font-family: 'Roboto-Bold';
  font-size: 14px;
`

export interface OptionProps {
  sortName: string
  sortBy: string
  key: number
  name: string
  isTab?: boolean,
  img?: string
}

interface SortPetsProps {
  margin?: string
  curSelect: OptionProps
  options: OptionProps[]
  updateData: (value: OptionProps) => void
  height?: number
  top?: string
  bg?: string
  select?: string
  wd?: string
  img?: string
}

export default function SortPets({margin, curSelect, options, updateData, height, top, bg, select, wd, img}: SortPetsProps) {
  const theme = useContext(ThemeContext)
  const onSelect = useCallback((d) => {
    updateData(d)
  }, [updateData])

  return (
    <Select
      selectedValue={img ? curSelect : curSelect.name}
      height={height || 40}
      margin={margin}
      top={top || '50px'}
      right='0px'
      minWidth={72}
      bg={bg ? bg : theme.btnBg1}
      radius={img ? '8px' : '40px'}
      pd='0 16px'
      color={img ? theme.bsText26 : theme.bsText4}
      listRadius='10px'
      select={select}
      wd={wd}
      icon={curSelect.isTab ? IconArrowBottom : IconArrowSort}
    >
      {
        options.map((d) => {
          return (
            <OptionItem
              key={d.key}
              pd={d.img ? "0 38px 0 16px"  : "4px 14px"}
              size="12px"
              weight="bold"
              select={select}
              wd={wd ? wd : '110px'}
              img={d.img}
              onMouseDown={() => {
                onSelect(d)
              }}
              className={d.key === curSelect.key ? curClassName : ''}
            >
              {
                d.img
                  ? <AutoRow>
                      {
                        !['collection'].includes(d.img) ? <ItemLeftImg d={d} src={d.img} alt=""/> : ''
                      }
                      <MintName d={d}>{d.name}</MintName>
                      <ItemImg d={d} cur={curSelect} src={selectArtworkImg} alt=""/>
                    </AutoRow>
                  : <AutoRow justify="flex-start">
                      <ItemImg d={d} cur={curSelect} src={selectImg} alt=""/>
                      <ItemName>{d.name}</ItemName>
                    </AutoRow>
              }
              {
                !d.isTab ? <ItemDesc d={d} src={d.key === curSelect.key ? sortAscCur : sortAsc} alt=""/> : ''
              }
            </OptionItem>
          )
        })
      }
    </Select>
  )
}